export const regex = {
  naturalNumbers: /^[1-9][0-9]*$/,
  alphabets: /^[A-Za-z\s]+$/,
  wholeNumbers: /^[0-9]{1,12}$/,
  idNumber: /^[0-9]+$/,
  decimal: /^\d+(\.\d{1,2})?$/,
  numbersAndDecimal: /^\d+(\.\d+)?$/,
  alphaNumeric: (isLimited = false) => {
    return isLimited ? /^[0-9a-zA-Z]{1,5}$/ : /^[0-9a-zA-Z\s]+$/
  },
  genericPhoneNumber : /^(\+)?\d*$/,
  phoneNumber: /^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm,
  arabPhoneNumber: /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/gm,
  number: (isNonZero = false) => {
    return isNonZero ? /^[0-9]{1,12}$/ : /^([1-9]|([1-9]\d{1,11}))$/
  },
  websiteRegex: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
  emailRegex: /^([a-zA-Z_])([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
  cnicRegex: /^[0-9]{5}-[0-9]{7}-[0-9]$/,
  nicopRegex: /^\d{6}-\d{6}-\d$/,
  idRegex: /@"^[0-9-]*$"/,
  nameRegex: /^[a-z ,.'-]+$/i,
  arabicRegex: /^[\u0621-\u064A0-9 ]+$/,
  /** Latin + Arabic (incl. common Persian letters) + Western & Persian-Indic digits + spaces */
  installmentNameAllowedPattern:
    /^[0-9a-zA-Z\s\u0621-\u064A\u0660-\u0669\u067E\u0686\u0698\u06A9\u06AF\u06CC\u06F0-\u06F9]*$/,
  installmentNameStripPattern:
    /[^0-9a-zA-Z\s\u0621-\u064A\u0660-\u0669\u067E\u0686\u0698\u06A9\u06AF\u06CC\u06F0-\u06F9]/g,
  ksaFinanceRegex: /^[a-zA-Z0-9\s\-/\\/]+$/, // this regex includes: alphanumeric, spaces, dashes and backslashes
  ksaOnlinePaymentRegex: /^[a-zA-Z0-9\s\-]+$/, //does not  include back-slashes
  alphaNumericWithSpecialCharacters : /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{}|;:'",.<>?/`~]*$/,
  cnicRegex : /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/,
  nicopRegex : /^[0-9]{6}-[0-9]{6}-[0-9]{1}$/,
  passportRegex: /^[A-Z0-9]{6,9}$/
}
